import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" })
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "company-details-area mb-120" }
const _hoisted_4 = {
  key: 0,
  class: "container"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "post-thumb" }
const _hoisted_8 = { class: "company-logo" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "company-area" }
const _hoisted_11 = { class: "company-info" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/map-2.svg",
  alt: ""
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Category: ", -1)
const _hoisted_15 = { class: "company-contact" }
const _hoisted_16 = { class: "websitet-link" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/web-5.svg",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("Website Link:")
], -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "social-area" }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-facebook" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-twitter" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-linkedin" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-dribbble" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-8" }
const _hoisted_34 = { class: "company-details-content" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h5", null, "About Company", -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<br><br><h5>Our Technologies</h5><div class=\"row pt-20\"><div class=\"col-sm-6 mb-50\"><div class=\"working-process\"><div class=\"icon\"><img src=\"assets/images/icon/creative-design.svg\" alt=\"\"></div><div class=\"work-content\"><div class=\"sl\">01</div><h6>Creative Design</h6><p>Creative design is a process that involves creating.</p></div></div></div><div class=\"col-sm-6 mb-50\"><div class=\"working-process\"><div class=\"icon\"><img src=\"assets/images/icon/react-next.svg\" alt=\"\"></div><div class=\"work-content\"><div class=\"sl\">02</div><h6>React Next.JS</h6><p>Creative design is a process that involves creating.</p></div></div></div><div class=\"col-sm-6 mb-50\"><div class=\"working-process\"><div class=\"icon\"><img src=\"assets/images/icon/html-tem.svg\" alt=\"\"></div><div class=\"work-content\"><div class=\"sl\">03</div><h6>HTML Template</h6><p>Creative design is a process that involves creating.</p></div></div></div><div class=\"col-sm-6 mb-50\"><div class=\"working-process\"><div class=\"icon\"><img src=\"assets/images/icon/wordpress.svg\" alt=\"\"></div><div class=\"work-content\"><div class=\"sl\">04</div><h6>WordPress</h6><p>Creative design is a process that involves creating.</p></div></div></div></div>", 4)
const _hoisted_43 = { class: "col-lg-4" }
const _hoisted_44 = { class: "company-dt-sb mb-60" }
const _hoisted_45 = { class: "company-overview-area mb-50" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h5", null, "Company Overview:", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "Company Name:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "Category:", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Location:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "Member Since:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "Company size:", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Completed Job:"),
  /*#__PURE__*/_createTextVNode(" 0")
], -1)
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-lg-12" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Latest Jobs:")
], -1)
const _hoisted_56 = { class: "job-listing-card" }
const _hoisted_57 = { class: "job-top" }
const _hoisted_58 = { class: "job-list-content" }
const _hoisted_59 = {
  class: "company-area",
  style: {"min-width":"fit-content"}
}
const _hoisted_60 = { class: "logo" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "company-details" }
const _hoisted_63 = { class: "name-location" }
const _hoisted_64 = { class: "job-discription" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Application Close:", -1)
const _hoisted_67 = { style: {"line-height":"1.5rem"} }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Summary: ", -1)
const _hoisted_69 = { class: "job-type-apply" }
const _hoisted_70 = { class: "job-type" }
const _hoisted_71 = { class: "light-green" }
const _hoisted_72 = {
  key: 0,
  class: "apply-btn"
}
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<div class=\"pagination-area\"><nav aria-label=\"...\"><ul class=\"pagination\"><li class=\"page-item disabled\"><a class=\"page-link\" href=\"#\" tabindex=\"-1\"></a></li><li class=\"page-item active\" aria-current=\"page\"><a class=\"page-link\" href=\"#\">01</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">02</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">03</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\"></a></li></ul></nav></div>", 1)
const _hoisted_74 = { class: "row mt-5" }
const _hoisted_75 = { class: "col-lg-12" }
const _hoisted_76 = { class: "section-title" }
const _hoisted_77 = { class: "be-comment-block" }
const _hoisted_78 = { class: "be-comment" }
const _hoisted_79 = { class: "be-img-comment" }
const _hoisted_80 = { href: "blog-detail-2.html" }
const _hoisted_81 = ["src"]
const _hoisted_82 = {
  key: 1,
  src: "https://bootdey.com/img/Content/avatar/avatar1.png",
  alt: "",
  class: "be-ava-comment"
}
const _hoisted_83 = { class: "be-comment-content" }
const _hoisted_84 = { class: "be-comment-name" }
const _hoisted_85 = { href: "blog-detail-2.html" }
const _hoisted_86 = { class: "be-comment-time" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o" }, null, -1)
const _hoisted_88 = { class: "be-comment-text" }
const _hoisted_89 = {
  key: 0,
  class: "form-block"
}
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-xs-12" }
const _hoisted_92 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "inner-banner",
          style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.company.cover_photo + ')' })
        }, _hoisted_2, 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.company)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: (_ctx.company.logo) ? _ctx.company.logo : '/assets/images/work-pages-logo.png',
                      alt: ""
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.company.name), 1),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_12,
                        _createTextVNode(" " + _toDisplayString(_ctx.company.location), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_13,
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.company.company_type), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("a", {
                        href: _ctx.company.weblink
                      }, _toDisplayString(_ctx.company.weblink), 9, _hoisted_18)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.company.facebook
                          }, _hoisted_22, 8, _hoisted_20)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.company.twitter
                          }, _hoisted_25, 8, _hoisted_23)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.company.linkedin
                          }, _hoisted_28, 8, _hoisted_26)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.company.dribble
                          }, _hoisted_31, 8, _hoisted_29)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      (_ctx.company.about)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.company.about), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, "No detail found...")),
                      _hoisted_38,
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.company.location), 1)
                      ]),
                      _hoisted_39
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _hoisted_47,
                            _createTextVNode(" " + _toDisplayString(_ctx.company.name), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _hoisted_48,
                            _createTextVNode(" " + _toDisplayString(_ctx.company.company_type), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _hoisted_49,
                            _createTextVNode(" " + _toDisplayString(_ctx.company.location), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _hoisted_50,
                            _createTextVNode(" " + _toDisplayString(_ctx.company.join_on), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _hoisted_51,
                            _createTextVNode(" " + _toDisplayString(_ctx.company.company_size), 1)
                          ]),
                          _hoisted_52
                        ])
                      ]),
                      _createVNode(_component_router_link, {
                        to: '/company-job/' + _ctx.company.id,
                        class: "primry-btn-2 lg-btn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Job Available (" + _toDisplayString(_ctx.company.jobs.length) + " )", 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.jobs, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: job.id,
                    class: "col-lg-12 mb-30"
                  }, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("img", {
                                src: (job.company_logo) ? job.company_logo : '/assets/images/work-pages-logo.png',
                                alt: ""
                              }, null, 8, _hoisted_61)
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("h5", null, [
                                  _createVNode(_component_router_link, {
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.job_title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: '/company-details?company_id=' + job.company_id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.company), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_65,
                                  _createTextVNode(" " + _toDisplayString(job.salary_range), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_66,
                                  _createTextVNode(_toDisplayString(job.expiration), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", _hoisted_67, [
                                  _hoisted_68,
                                  _createTextVNode(_toDisplayString(job.job_description.slice(0, 30)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("span", _hoisted_71, _toDisplayString(job.working_mode) + " " + _toDisplayString(job.expiration), 1)
                        ]),
                        (!_ctx.isJobExpired(job.expiration))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              (_ctx.loggedIn)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "primry-btn-2 y-btn lg-btn",
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug, 'apply')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Apply Now")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { name: 'login' },
                                    class: "primry-btn-2 y-btn lg-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Login to apply")
                                    ]),
                                    _: 1
                                  }))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128)),
                _hoisted_73
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("h4", null, "Reviews (" + _toDisplayString(_ctx.company_reviews_count) + "):", 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company_reviews, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("a", _hoisted_80, [
                          (_ctx.checkReviewImageExists(item.author_image))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: item.author_image,
                                alt: "Image",
                                class: "be-ava-comment"
                              }, null, 8, _hoisted_81))
                            : (_openBlock(), _createElementBlock("img", _hoisted_82))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("span", _hoisted_84, [
                          _createElementVNode("a", _hoisted_85, _toDisplayString(item.author_name), 1)
                        ]),
                        _createElementVNode("span", _hoisted_86, [
                          _hoisted_87,
                          _createTextVNode(" May 27, 2015 at 3:14am " + _toDisplayString(item.reviewed_on), 1)
                        ]),
                        _createElementVNode("p", _hoisted_88, _toDisplayString(item.review), 1)
                      ])
                    ]))
                  }), 256)),
                  (_ctx.role == 2)
                    ? (_openBlock(), _createElementBlock("form", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-input",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reviewForm.review) = $event)),
                                placeholder: "Your Review"
                              }, null, 512), [
                                [_vModelText, _ctx.reviewForm.review]
                              ])
                            ])
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createReview && _ctx.createReview(...args))),
                            class: "primry-btn-2 lg-btn w-unset",
                            type: "button"
                          }, "Submit Review")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}